module.exports = __webpack_public_path__ + "img/SequinNights.2a79578e.jpg";